import { defineNuxtPlugin } from 'nuxt/app';
import type {
  AddProductsOptions,
  CartType,
  ModifyCartItem
} from '~/stores/cartStore/model';

declare global {
  interface Window {
    baslerApi: {
      // XXX: Types of property 'decoratedProduct' are incompatible.
      // Types have separate declarations of a private property 'shippingTime'.
      // although both are { quantity: number; } ???
      cart: {
        addProducts: (
          cartItems: ReadonlyArray<ModifyCartItem>,
          cartType: CartType,
          options?: AddProductsOptions
        ) => Promise<unknown>;
      };
    };
  }
}

/**
 * Expose cart mutations for basler tools. The cart store is loaded on demand so
 * it stays out of the eager entry chunk (header already hydrate-on-idle).
 */
export default defineNuxtPlugin(() => {
  window.baslerApi = {
    cart: {
      addProducts: async (cartItems, cartType, options) => {
        const { useCartStore } = await import('~/stores/cartStore/cartStore');
        return useCartStore().addProducts(cartItems, cartType, options);
      }
    }
  };
});
